import { InvoiceStatus } from '@link/agent/services/const';

export default {
  common: {
    search: '検索',
    keyword: 'キーワード',
    cancelAll: '一括キャンセル',
    complete: '完了'
  },
  layouts: {
    sidebar: {
      notifications: '通知',
      contractsList: '契約管理',
      agents: '旅行代理店管理',
      booking: '予約管理',
      settings: '設定',
      changePassword: 'パスワード変更',
      finance: '支払管理',
      bulkOrder: '一括注文',
      activityList: '在庫商品一覧'
    }
  },
  views: {
    activityList: {
      pageTitle: '在庫商品一覧',
      searchTitle: '商品検索',
      activityId: '商品ID',
      activityUrl: '商品URL',
      title: '商品名',
      supplier: 'サプライヤー',
      supplierId: 'サプライヤーID',
      supplierName: 'サプライヤー名',
      category: 'カテゴリ',
      country: '商品国・地域',
      confirmationType: '在庫タイプ',
      inSalePeriod: '販売期間内',
      unspecified: '指定なし',
      salePeriod: '販売期間',
      netPrice: '卸価格',
      grossPrice: '販売価格（GROSS）',
      unlimited: '無期限',
      downloadCsv: 'CSVをダウンロード',
      snapshotHint:
        '表示されているデータは前日時点のものです（毎日深夜更新）。最終更新日時：{{time}}'
    },
    bulkBookingDetail: {
      history: '操作内容',
      action: '操作',
      operator: '操作者',
      date: '日付',
      message: 'メッセージ',
      notifyPayment: '送金通知',
      paymentDate: '送金日',
      paymentConfirmed: '送金を確認しました',
      infoSentToSupplier: '催行会社へ情報を送信しました'
    },
    bulkBookingForm: {
      operator: '操作者',
      paymentDate: '送金予定日',
      message: 'メッセージ',
      agentReservationNo: '旅行代理店予約番号（備考）',
      agentReservationNote: '旅行代理店予約特記事項'
    },
    addPrepayment: {
      agentId: '旅行代理店ID',
      agentName: '旅行代理店名',
      address: '会社住所',
      date: '支払期日',
      currency: '通貨',
      amount: '支払金額',
      note: 'LINKTIVITYの営業担当宛に前払い請求書をメールで送付してください。',
      submit: '前払い請求書の作成',
      reset: 'リセット'
    },
    financeHistory: {
      title: '支払履歴',
      dataAggregation: 'データ集計',
      aggregationUnit: '集計単位',
      targetPeriod: '対象期間',
      monthly: '月単位',
      weekly: '隔週単位',
      confirmed: '確定済み',
      canceledRefund: 'キャンセルによる返金',
      differenceAdjusted: '差額調整済み',
      totalAmount: '合計金額',
      cancellationFee: '(内キャンセル料)',
      totalPaymentAmount: '支払金額合計',
      price: '({{currency}})',
      salesPrice: '販売価格',
      wholesalePrice: '卸価格',
      commission: 'コミッション',
      transactionSearch: '支払検索',
      applicationDate: '申込日',
      participationDate: '参加日',
      transactionStatus: '予約ステータス',
      keyword: 'キーワード',
      activity: '商品',
      plan: 'プラン',
      supplier: '催行会社',
      reservationNumber: '予約番号',
      currency: '通貨'
    },
    financeTransactions: {
      title: '精算書',
      transactionStatus: '精算状況',
      difference: '差額調整',
      dueDate: '請求書発行日',
      invoiceNumber: '支払通知書ID',
      date: '請求時期',
      fromDate: '{{fromDate}}～{{toDate}}',
      currency: '通貨',
      amount: '支払金額合計',
      adjustedAmount: '調整金額',
      finalAmount: '最終合計金額',
      adjust: '調整',
      showjust: '表示',
      change: '支払済み',
      invoice: 'ダウンロード',
      jaInvoice: '支払通知書(日本語)',
      jaInvoiceDetails: '明細書(日本語)',
      enInvoice: '支払通知書(英語)',
      enInvoiceDetails: '明細書(英語)',
      attachment: '添付ファイル',
      changeTitle: '支払済みですか？',
      changeMessage: '取引状態を「支払済み」に変更します'
    },
    financeAccount: {
      title: '残高管理',
      listTitle: 'チャージ履歴',
      accountBalance: 'アカウント残高',
      accountBuffer: 'アカウントバッファー',
      deposit: 'チャージする',
      generatePrepaidInvoice: '前払い請求書の作成',
      billingCycle: '精算サイクル',
      paymentMethod: 'お支払方法',
      currency: '通貨',
      contractNote: '上記の設定は契約内容に基づいています。',
      contactSupport:
        '変更が必要な場合は、LINKTIVITY担当者までご連絡ください。',
      date: '日時',
      amount: '金額',
      prepaidInvoice: '前払い請求書',
      transactionStatus: 'ステータス',
      remark: '備考',
      accountBalanceAmount: 'アカウント前残高',
      accountBalanceAfterAmount: 'チャージ後残高',
      accountBufferAmount: 'アカウントバッファー',
      verificationCode: '確認コード',
      enterDepositAmount: 'チャージ金額を入力してください',
      depositAmount: 'チャージ金額',
      chargeCompleted: '送金完了',
      cancel: 'キャンセル',
      confirmChargeCompleted: '送金完了をLINKTIVITYに通知します',
      changeStatusToCharged: 'ステータスを「送金完了」に変更します',
      change: '操作',
      confirmCancel: 'キャンセルしてもよろしいですか？',
      changeStatusToCancelled: 'ステータスを「キャンセル」に変更します',
      insufficientBalanceNotification: '残高不足通知を設定',
      notificationDialogTitle: '残高不足通知の設定',
      notificationDialogSubtitle:
        '残高が指定金額を下回ったときにメールでお知らせします',
      notificationReceiveLabel: '通知を受け取る',
      notificationEnabled: '受け取る',
      notificationDisabled: '受け取らない',
      notificationThresholdLabel: '指定金額',
      notificationSave: '設定を保存する'
    },
    dashboard: {
      title: 'ダッシュボード'
    },
    searchActivities: {
      title: '新規予約',
      filter: {
        lang: '掲載言語',
        otaId: '旅行代理店',
        supplierId: '催行会社',
        categories: 'カテゴリ',
        country: '出発地',
        activityTitle: '商品名'
      },
      plan: 'プラン',
      openBookingForm: '予約フォームを開く',
      viewDetail: '詳細を見る',
      total: '検索結果・{{total}}件',
      location: '{{country}}',
      city: '・{{city}}',
      supplier: '{{name}}({{id}})'
    },
    activityDetail: {
      plan: 'プランを選択',
      plans: {
        stockAndPrice: '在庫・価格',
        calendar: '在庫カレンダー',
        priceCalendar: '価格カレンダー',
        quantity: '在庫数',
        currentPrice: '当日価格',
        noDateSelected: '日付を選択してください',
        unit: 'ユニット',
        displayPrice: '販売価格',
        netPrice: '卸価格',
        otherDate: '他の適用日',
        priceTable: '価格表',
        priceGroup: '料金グループ',
        applicablePeriod: '適用期間',
        cannotBeBookIndependently: '単独購入不可',
        commission: 'コミッション'
      }
    },
    bookingForm: {
      title: '予約フォーム',
      steps: {
        step1: '基本情報',
        step2: '予約時必要情報',
        step3: '予約申込'
      },
      prev: '前のステップ',
      next: '次のステップ',
      form: {
        plans: 'プラン',
        targetDate: '参加日',
        time: '開始時間',
        amount: '人数',
        amountDesc: '予約数量制限：{{capacity}}',
        amountDescBulk:
          '予約数量制限：{{capacity}}；1回につき、各ユニットの予約は最大999枚までとなります。',
        accountBalance: 'アカウント残高',
        availableAmount: '利用可能額',
        checkPrice: '空き状況と価格の確認',
        checkList: '参加制限',
        checkListTip: 'ご予約前にご確認ください',
        operator: '操作者',
        paymentDate: '送金予定日',
        message: 'メッセージ',
        requiredInfo: '必要情報',
        requiredInfoPerParticipant: '必要情報 (参加者ごと)',
        allotmentQuantity: '数量 {{quantity}}',
        paymentCurrency: '支払金額(販売価格）',
        totalPriceForBooking: '現地通貨の合計額',
        paymentCurrencyExchange: '為替レート',
        unit: 'ユニット',
        representative: '参加者代表',
        pleaseSelectUnit: 'ユニットを選択してください',
        displayPrice: '販売価格',
        netPrice: '卸価格'
      },
      bookingConfirmation: {
        title: '予約を受付しました',
        message: '申込みが完了し、催行会社へ情報が送信されました',
        reservationNumber: '予約番号',
        print: '印刷用',
        display: '表示用'
      },
      participantInfo: {
        firstName: '代表者（名）',
        lastName: '代表者（姓）',
        agentReservationNo: '旅行代理店予約番号（備考）',
        agentReservationNote: '旅行代理店予約特記事項'
      },

      bookingFields: {
        participantEmailAddress: '参加者メールアドレス',
        hotelName: '宿泊先名',
        hotelAddress: '宿泊先住所',
        hotelReservationLastName: '宿泊代表者氏名（姓）',
        hotelReservationFirstName: '宿泊代表者氏名（名）',
        hotelReservationName: '宿泊代表者氏名',
        hotelTel: '宿泊先電話番号',
        arrivalDate: '現地到着日',
        arrivalTime: '到着時刻',
        arrivalFlightNumber: 'フライト到着便名',
        departureDate: '出発日',
        departureTime: '出発時刻',
        departureFlightNumber: 'フライト出発便名',
        destinationEmail: '現地連絡先（メールアドレス）',
        destinationTel: '現地連絡先（電話番号）',
        gender: '性別',
        agentChannelRegion: '旅行代理店所在国・地域',
        agentChannelLanguage: '旅行代理店言語',
        participantResidentRegion: '参加者居住国・地域',
        participantLanguage: '参加者言語',
        passengersQuantity: '乗車人数',
        prescriptionMaskQuantityFree: '度付きマスク希望 ※無料',
        prescriptionMaskQuantityPaid: '度付きマスク希望 ※現地払い',
        preferredStartTime: '希望開始時刻',
        preferredPickUpLocation: 'お迎え・乗車場所',
        preferredDropOffLocation: 'お送り・降車場所',
        participantsQuantity: '参加人数',
        luggageQuantity: 'スーツケース数（合計）',
        childrenWithoutSeatQuantity: '座席を必要としない幼児',
        childSeatQuantityPaid: 'チャイルドシート利用（現地払い）',
        childSeatQuantityFree: 'チャイルドシート利用（無料）',
        guideJa: '日本語ガイド希望',
        driverJa: '日本語ドライバー希望',
        guideEn: '英語ガイド希望',
        driverEn: '英語ドライバー希望',
        guideZh: '中国語ガイド希望',
        driverZh: '中国語ドライバー希望',
        guideKo: '韓国語ガイド希望',
        driverKo: '韓国語ドライバー希望',
        preferredGuideLanguageCode: 'ご希望のガイド言語',
        preferredDriverLanguageCode: 'ご希望のドライバー言語',
        passportNationality: '国籍',
        passportFirstName: '参加者名（パスポート記載のローマ字名）',
        passportLastName: '参加者姓（パスポート記載のローマ字姓）',
        dateOfBirth: '生年月日',
        age: '年齢',
        passportNumber: 'パスポート番号',
        eyesight: '視力',
        weightKg: '体重（kg）',
        heightCm: '身長（cm）',
        shoeSizeCm: '靴のサイズ（cm）',
        weightLbs: '体重（lbs）',
        heightIn: '身長（ft/in）',
        clothesSize: '服のサイズ',
        vegetarianMeals: 'ベジタリアンフード希望',
        divingExperienceTimes: 'ダイビング経験本数',
        rentalEquipmentsFree: '器材レンタル希望 ※無料',
        rentalEquipmentsPayLocally: '器材レンタル希望 ※現地払い',
        male: '男性',
        female: '女性',
        other: 'その他',
        yes: 'はい',
        no: 'いいえ'
      },

      alert: {
        warning:
          'ご希望の日付に利用可能な在庫数は、ご希望の人数よりも少なくなります。日付または人数を変更してください。',
        info: 'キャンセルポリシーに合意し、申し込みを行います',
        cannotBookAlone: '選択したチケットは単独での購入ができません。'
      }
    },
    reservations: {
      title: '未確定の予約'
    },
    agentDetail: {
      title: '旅行代理店情報'
    },
    orgList: {
      title: 'グループ管理'
    },
    agentAccountList: {
      title: 'アカウント管理'
    },
    bookReservations: {
      paymentAppliedDate: '支払申込日',
      id: 'ID',
      productPlan: '商品/プラン',
      expirationDate: '有効期限',
      participationDate: '参加日（開催地の現地時間基準）',
      holdReservation: '未確定の予約',
      count: '件'
    }
  },
  const: {
    allotmentStatus: {
      plenty: '在庫あり',
      insufficient: '残りわずか',
      empty: '在庫なし',
      unavailable: '販売不可'
    },
    bookingStatus: {
      yes: '予約可能',
      no: '予約不可'
    },
    activityTags: {
      NON_CANCELLABLE: 'キャンセル不可',
      FREE_CANCEL_BEFORE_ISSUE_TICKET: '引換前キャンセル無料',
      ADVANCE_CANCELLATION_POLICY: '特殊キャンセルポリシー',
      INSTANT_BOOK: '即予約',
      NON_QR_CODE: '目視バウチャー',
      QR_CODE: 'QRバウチャー',
      ETICKET: 'もぎりチケット（スマホ必要）'
    },
    invoiceStatus: {
      [InvoiceStatus.InvoiceStatusPending]: '未払',
      [InvoiceStatus.InvoiceStatusConfirmed]: '支払完了',
      [InvoiceStatus.InvoiceStatusPaid]: '入金確認待ち',
      [InvoiceStatus.InvoiceStatusCancelled]: 'キャンセル済'
    }
  }
};
